import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient, HttpHandler, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { CommonAppModule } from './shared/common/common-app.module';
import { ApplicationModule } from './layouts/app/application.module';
import { AdminModule } from './layouts/admin/admin.module';
import { ReportsModule } from './layouts/reports/reports.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './shared/shared.module';
import { AppLayoutComponent } from './layouts/app/app-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { ReportsLayoutComponent } from './layouts/reports/reports-layout.component';
import { HeaderComponent } from './shared/header/header.component';
import { AlertComponent } from './shared/common/components/alerts/alerts.component';
import { GlobalErrorHandler } from './shared/common/services/global-error.handler';
import { AuthenticationService } from './authentication/services/authentication.service';
import { AuthenticationObserver } from './authentication/services/authentication.observer';
import { AuthGuard } from './authentication/guard/auth-guard.service';
import { HttpService } from './shared/common/helper/httpService';
import { AuthInterceptor } from './shared/common/services/httpInterceptor.service';
import { PcnGuard } from './shared/common/services/pcn-guard.service';
import { AdminGuard } from './layouts/services/admin-guard.service';
import { TermsModal } from './authentication/services/terms-modal.service';
import { Global } from './app.global';
import { GlobalObservables } from './app.global.observer';
import { UserGuard } from './layouts/services/user-guard.service';
import { AdminAccessGuard } from './layouts/services/admin-access-guard.service';
import { ReportsAccessGuard } from './layouts/services/reports-access-guard.service';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { CorsRequestInterceptor } from './shared/common/services/corsRequestIntrerceptor';

/* Kendo Modules */
import { GridModule } from '@progress/kendo-angular-grid';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { IntlModule } from '@progress/kendo-angular-intl';
import { LabelModule } from '@progress/kendo-angular-label';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { CheckBoxModule } from '@progress/kendo-angular-inputs';
// import { Select2Module } from "ng-select2-component";
import { Select2Module } from '../../projects/ng-select2-component/src/public_api';

import { clearScreenLocksFactory } from './app-init.factory';
import { StorageService } from './shared/common/services/storage.service';
import { UserSettingsService } from './shared/common/services/settings.service';

@NgModule({
  imports: [
    NgbModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    HttpClientModule,
    SharedModule,
    AppRoutingModule,
    AuthenticationModule,
    ApplicationModule,
    AdminModule,
    ReportsModule,
    CommonAppModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatNativeDateModule,
    ToastModule,
    GridModule,
    BrowserAnimationsModule,
    DialogsModule,
    IntlModule,
    LabelModule,
    InputsModule,
    DropDownsModule,
    ButtonsModule,
    CheckBoxModule,
    Select2Module,
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    AlertComponent,
    AppLayoutComponent,
    AuthLayoutComponent,
    AdminLayoutComponent,
    ReportsLayoutComponent,
  ],
  providers: [
    MatDatepickerModule,
    Global,
    GlobalObservables,
    HttpService,
    HttpClient,
    GlobalErrorHandler,
    AuthenticationService,
    AuthenticationObserver,
    AuthGuard,
    PcnGuard,
    UserGuard,
    AdminAccessGuard,
    ReportsAccessGuard,
    AdminGuard,
    TermsModal,
    StorageService,
    UserSettingsService,
    {
      provide: HttpService,
      useFactory: httpFactory,
      deps: [HttpHandler, GlobalObservables, Router],
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CorsRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: clearScreenLocksFactory,
      deps: [StorageService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

export function httpFactory(handler: HttpHandler, globalObs: GlobalObservables, router: Router) {
  return new HttpService(handler, globalObs, router);
}
